
class BrowserDetectionService {

    private isFirefoxCached: boolean|null = null;
    public isFirefox() {
        if (this.isFirefoxCached == null) {
            this.isFirefoxCached = navigator.userAgent.toLowerCase().includes('firefox');
        }
        return this.isFirefoxCached;
    }

}

const BROWSER_DETECTION_SERVICE_INSTANCE = new BrowserDetectionService();

export {BROWSER_DETECTION_SERVICE_INSTANCE};
